import React from 'react';
import styled from 'styled-components';
import sageIcon from '~/assets/public/sage-intacct-icon.svg';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 1.2rem;
  margin-top: -0.25rem;
  margin-bottom: 0.05rem;
`;

const Image = styled.img.attrs({ src: sageIcon })`
  width: 1rem;
  height: 1rem;
  filter: grayscale(100%);
  opacity: 0.6;
`;

export default function SageGrey() {
  return (
    <Wrapper>
      <Image />
    </Wrapper>
  );
}
